
import React, { useRef, useEffect } from 'react';
import './player.css';

const CoursePlayer = ({ videoUrl, onVideoEnded }) => {
    const videoRef = useRef(null);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.load(); // Load the new source
            videoRef.current.play().catch(error => console.log("Autoplay was prevented: ", error));
        }
    }, [videoUrl]);

    if (!videoUrl) {
        return <div className="player-placeholder">Selecciona un video para comenzar.</div>
    }

    return (
        <video
            ref={videoRef}
            width='100%'
            height='100%'
            controls
            autoPlay
            onEnded={onVideoEnded}
        >
            <source src={videoUrl} type='video/mp4' />
            Tu navegador no soporta el tag de video.
        </video>
    );
}

export default CoursePlayer;